import { IDisplayPreference } from './definitions';

const arabic = new Intl.NumberFormat('ar-AE');
const persian = new Intl.NumberFormat('fa-IR');

export const PersianPreference: IDisplayPreference = {
  hour: (x) => persian.format(x),
  minute: (x) => {
    let exp = persian.format(x);
    if (exp.length === 1) {
      exp = persian.format(0) + exp;
    }
    return exp;
  },
  separator: ':',
  period: (x) => x === 'AM' ? 'ØµØ¨Ø­' : 'Ø¹ØµØ±',
  clockHour: (x) => persian.format(x),
  clockMinute: (x) => persian.format(x),
  labels: {
    ok: 'ØªØ§ÛÛØ¯',
    cancel: 'ÙØºÙ'
  }
};

export const ArabicPreference: IDisplayPreference = {
  hour: (x) => arabic.format(x),
  minute: (x) => {
    let exp = arabic.format(x);
    if (exp.length === 1) {
      exp = arabic.format(0) + exp;
    }
    return exp;
  },
  separator: ':',
  period: (x) => x === 'AM' ? 'ØµØ¨Ø§Ø­Ø§' : 'ÙØ³Ø§Ø¡',
  clockHour: (x) => arabic.format(x),
  clockMinute: (x) => arabic.format(x),
  labels: {
    ok: 'Ø­Ø³ÙØ§',
    cancel: 'Ø¥ÙØºØ§Ø¡'
  }
};

export const ChinesePreference: IDisplayPreference = {
  hour:  (x) => x,
  minute: (x) => {
    let exp = x;
    if (exp.length === 1) {
      exp = 'Û°' + exp;
    }
    return exp;
  },
  separator: ':',
  period: (x) => x === 'AM' ? 'ä¸å' : 'ä¸å',
  clockHour: (x) => x,
  clockMinute: (x) => x,
  labels: {
    ok: 'ç¡®å®',
    cancel: 'åæ¶'
  }
};

export const Preference = (locale: string): IDisplayPreference => {
  switch (locale) {
    case 'fa':
        return PersianPreference;
    case 'ar':
        return ArabicPreference;
    case 'zh':
        return ChinesePreference;
    default:
      return null;
  }
};
